import React from "react";
import dayjs, { LOCALE } from "utils/dayjs";
import cx from "classnames";
import { get } from "utils/lodash";

export default function Day({
  data,
  allAccepted = false,
  isSelected = false,
  className,
  ...props
}: {
  data: any;
  isSelected?: boolean;
  className?: string;
  allAccepted?: boolean;
  onClick: () => void;
}) {
  const date = get(data, "date");
  const isToday = date.isToday();
  const numberBookingsOnDay = get(data, "numberBookingsOnDay", 0);
  const numberWaitingBookings = get(data, "numberWaitingBookings", 0);
  return (
    <div className={`${className}`} {...props}>
      <div
        className={cx(
          "relative flex flex-col items-center justify-between w-12 h-[4.2rem] rounded-lg py-1.5",
          {
            "bg-white text-primary border border-primary": isSelected,
            "bg-primary border border-primary text-white":
              !isSelected && isToday,
            "bg-gray-01 border border-gray-01": !isSelected && !isToday,
          }
        )}
      >
        <span className="text-[0.625rem]">
          {isToday
            ? "Hôm nay"
            : LOCALE[date.format("ddd") as keyof typeof LOCALE]}
        </span>
        <span className="text-base">{date.format("D")}</span>
        <span className="text-[0.625rem]">
          {!!numberBookingsOnDay ? `${numberBookingsOnDay}LH` : "\u00A0"}
        </span>
        {allAccepted && (
          <span className="absolute -top-[5px] -right-[5px] w-3 h-3 rounded-full bg-success text-white z-10"></span>
        )}
        {numberWaitingBookings > 0 && (
          <span className="absolute -top-[5px] -right-[5px] w-3 h-3 rounded-full bg-danger text-white z-10"></span>
        )}
      </div>
    </div>
  );
}
